import { AxiosResponse } from 'axios'

// Имя файла задаёт сервер в Content-Disposition; без заголовка — запасное
const getFileNameFromResponse = (
  response: AxiosResponse<Blob>,
  fallbackName: string
): string => {
  const contentDisposition = response.headers?.['content-disposition']
  if (!contentDisposition) {
    return fallbackName
  }

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1])
  }

  const simpleMatch = contentDisposition.match(/filename="?([^"]+)"?/i)
  return simpleMatch?.[1] ?? fallbackName
}

export const downloadBlobResponse = (
  response: AxiosResponse<Blob>,
  fallbackName: string
) => {
  const blobUrl = window.URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = getFileNameFromResponse(response, fallbackName)
  link.click()
  window.URL.revokeObjectURL(blobUrl)
}
